import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from "react-dom";

import Popover from "src/core/gd-components/gd-popover/popover";
import TimeSelectorPopoverContent from "./popover-content";
import DatetimeUtils from "core/gd/utils/datetime-utils";
import Format from "core/gd/utils/format";
import Moment from 'moment';

export default class TimePicker extends React.Component {
    static propTypes = {
        renderType: PropTypes.oneOf(['default', 'standalone']),

        form: PropTypes.object,                 // form manager
        name: PropTypes.string,                 // name of the form field

        placeholderText: PropTypes.string,
        minValue: PropTypes.object,
        value: PropTypes.object,
        timeStep: PropTypes.number,             // minutes
        popoverMinWidth: PropTypes.number,

        onChange: PropTypes.func
    };

    static defaultProps = {
        renderType: 'default',

        placeholderText: 'Select time',
        value: Moment(),
        timeStep: 15,

        attachmentType: 'horizontal'
    }

    state = {
        showPopover: false
    }

    constructor(props) {
        super(props);

        if (this.props.form) this.props.form.registerFormComponent(this.props.name,this);
    }

    togglePopover = (e) => {
        e.stopPropagation();
        this.setState({
            showPopover: !this.state.showPopover
        })
    }

    hidePopover = () => {this.setState({showPopover: false})}

    onOptionClick = (value) => {
        if (this.props.form) this.props.form.onFormComponentValueChange(this.props.name,value);

        this.setState({
            showPopover: false
        }, ()=>{
            if (this.props.onChange) this.props.onChange(value);
        })
    }

    _getValue = () => {
        const value = this.props.form ? this.props.form.getValue(this.props.name) : this.props.value;
        return value ? DatetimeUtils.stickToSteps(value, this.props.timeStep) : null;
    }

    renderPopover() {
        if (this.state.showPopover) {
            const minValue = this.props.minValue ? DatetimeUtils.stickToSteps(this.props.minValue) : null;

            return (
                <Popover className="gd-time-picker-popover-content"
                         attachmentType="horizontal"
                         onClickOutside={()=>{this.hidePopover()}}
                         getTargetFunc={()=>findDOMNode(this)}>
                    <TimeSelectorPopoverContent selectedValue={this._getValue()}
                                                timeStep={this.props.timeStep}
                                                minValue={minValue}
                                                popoverMinWidth={this.props.popoverMinWidth}
                                                onOptionClick={this.onOptionClick}/>
                </Popover>
            )
        }
    }

    renderValue() {
        const value = this._getValue();
        return value ? Format.timeUserFormat(value) : this.props.placeholderText;
    }

    render() {
        switch (this.props.renderType) {
            case "standalone":
                return (
                    <div className={Classes("gd-time-picker", "ui5-txt-default", this.props.className)} onClick={this.togglePopover}>
                        <div className="ui5-ico-12 i5-my-time m-r-10"/>
                        <div className="txt">{this.renderValue()}</div>
                        {this.renderPopover()}
                        {this.props.children}
                        <div className="ui5-arrow-toggle s8 open m-l-10"/>
                    </div>
                );

            default:
                return (
                    <div className={Classes("gd-time-picker", "default-render-type", this.props.className)} onClick={this.togglePopover}>
                        {this.renderValue()}
                        {this.renderPopover()}
                        {this.props.children}
                        <div className="arrow ui5-arrow-toggle s11 open"/>
                    </div>
                );
        }
    }
}
